(function () {
	'use strict';

	a3_cabin_reports.factory('TimeLogFactory', TimeLogFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name TimeLogFactory
    * @description 
    *   Get list, Update list & Acknowledge schedule changes
    * @ngInject
    */
	function TimeLogFactory(GenericService) {
        /**
         * Initialize the ScheduleChanges
         * @memberof TimeLogFactory
         */
        function TimeLog() {
            this.Date = null;
            this.ClientTimeLog = "";
            this.ApiTimeLog = "";
        }

        var objType = 'timeLogs';
        var objCallback = TimeLog;

        
		var service = {
			timeLogToStorage : timeLogToStorage,
            cleanOldData: cleanOldData
		};

        /**
         * Save all time logs to storage
         * @memberof TimeLogFactory
         * @param {Array} CrewPhoneNumbers
         */
		function setTimeLogsToStorage(objList) {
			GenericService.saveAll(objList,objType);
        }

        /**
         * get all time logs from storage
         * @memberof TimeLogFactory
         */
        function getTimeLogsFromStorage() {
			return GenericService.list(objType,objCallback);
		}

		/**
		 * Save the time log to storage
         * @memberof TimeLogFactory
		 * @param  clientTimeLog 
         * @param  apiTimeLog 
		 */
        function timeLogToStorage(timeLogStr, apiTimelog) {
            var timeLog = new TimeLog();
            timeLog.Date = moment.utc();
            timeLog.ClientTimeLog = timeLogStr;
            timeLog.ApiTimeLog = apiTimelog;
            GenericService.add(timeLog, objType, objCallback);
        }

        /**
		 * Clean old time logs
		 */
        function cleanOldData(){
            var now = moment();
            var timeLogs = getTimeLogsFromStorage();
            var latestTimeLogs = [];
            //Filter out crew check-ins of old flights
            timeLogs.forEach(x => {
                var date = moment(x.Date)
                if( now.diff(date, 'days') < 2){
                    latestTimeLogs.push(x);
                }
            });
            
            setTimeLogsToStorage(latestTimeLogs);
        }
        

		return service;
	}
})();
